import React from 'react';
import { connect } from 'react-redux';
import {
	Route,
	Redirect,
} from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={
			props => {
				const { loggedIn } = rest;

				return loggedIn? (
					<Component {...props} />
				) : (
					<Redirect
						to={{
							pathname: "/login",
							state: { from: props.location }
						}}
					/>
				);
			}
		}
	/>
);

function mapStateToProps(state) {
	const { loggedIn } = state.auth;
	return { loggedIn };
}

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js